export const ERROR_CODE = {
  GETWAY_USER_ERROR: '3002',
  TOKEN_OVERTIME: '4006',
  INVALID_TOKEN: '4005',
  SUCCESS: '2000',
  WITHOUT_TENANT_ID: '4010', // 缺少租户id
  NO_LOGIN: '4003',
  USER_NOT_EXIST: '40105',
  LOGIN_REQUIRED: '40101',
  SESSION_TIME_OUT: '4009',
  REPEAT_LOGIN: '4008'
};

export const needLoginCodes = [
  ERROR_CODE.GETWAY_USER_ERROR,
  ERROR_CODE.LOGIN_REQUIRED, // LOGIN_REQUIRED("40101", "需要重新登陆"),
  ERROR_CODE.USER_NOT_EXIST, //USER_NOT_EXIST("40105", "用户不存在"),
  ERROR_CODE.NO_LOGIN, //NO_LOGIN("4003", "未登陆"),
  ERROR_CODE.INVALID_TOKEN, //INVALID_TOKEN("4005", "无效的TOKEN"),
  ERROR_CODE.SESSION_TIME_OUT, // 会话超时退出
  ERROR_CODE.REPEAT_LOGIN // 该账号已在别处登录
];
